import "../Main.css";
import axios from "axios";
import { MenuBar } from "../../components/MenuBar";
import Address from "../../components/Address";
import { useEffect, useState } from "react";
import { getSubjectInfoBySolutionId } from "../../services/SolutionDetailAPI";
import SolutionSubjectCard from "../../components/SolutionSubjectCard";

const SolutionDetail = () => {
    const [titleImage, setTitleImage] = useState();
    const [titleText, setTitleText] = useState();
    const [currentPageId, setcurrentPageId] = useState();
    const [solutionName, setSolutionName] = useState();
    const [subjectList, setSubjectList] = useState();
    const [subjectCardList, setSubjectCardList] = useState([]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // 부드럽게 스크롤링되도록 설정 (선택적)
        });
    };

    useEffect(() => {
        scrollToTop();
        setcurrentPageId(window.location.href.split("id=")[1]);
        axios.get("/api/solution/title").then((res) => {
            setTitleImage(res.data.imageUrl);
            setTitleText(res.data.name);
        });
    }, []);

    useEffect(() => {
        currentPageId &&
            getSubjectInfoBySolutionId(currentPageId).then((res) => {
                setSolutionName(res["solutionName"]);
                setSubjectList(res["subjectList"]);
            });
    }, [currentPageId]);

    useEffect(() => {
        let cards = [];
        subjectList &&
            subjectList.map((subject) => {
                cards.push(<SolutionSubjectCard 
                    key={subject.subjectID} 
                    subjectId={subject.subjectID}  
                    moreInfoFlag={subject.moreInfoFlag}
                    />);
            });
        setSubjectCardList(cards);
    }, [subjectList]);
 
    return (
        <div className="h-screen w-screen min-w-[1200px]">
            <MenuBar selected_page={7} />
            <div
                className="w-full min-w-[1200px] h-[300px] bg-black text-8xl font-bold text-white flex items-center justify-center bg-[length:100%_100%]"
                style={{ backgroundImage: `url(${titleImage})` }}
            >
                {titleText}
            </div>
            <div style={{display:"flex" , flexDirection:"column", alignItems:"center", width:"100%", minWidth:"1200px"}}>
            <div className="w-[1210px]" style={{ marginTop: "1%", fontSize: "xx-large", fontWeight: "bold" }}>
                {solutionName}
            </div>

            <div className="h-full w-[1200px] bg-white mb-10">
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>{subjectCardList}</div>
            </div>
            </div>
        
            <Address />
        </div>
    );
};

export default SolutionDetail;
